<div *ngIf="diagramJson$ | async as diagramJson" class="de-toolbar">
  <q9-toolbar>
    <div q9-left-content>
      <div
        *ngIf="!isActivityDisabled()"
        [matTooltip]="BUTTON_TYPES.ACTIVITY | transform: getTooltipText.bind(this) | translate">
        <q9-icon-button
          class="sb-toolbar-actions"
          icon="palette"
          matTooltipPosition="above"
          [disabled]="isViewMode()"
          [class.is-pressed]="showActivityToolbar()"
          [attr.aria-pressed]="showActivityToolbar()"
          (click)="toggleActivityToolbar()"></q9-icon-button>
      </div>

      <div
        *ngIf="isAgentInstruction() && !isActivityDisabled()"
        [matTooltip]="BUTTON_TYPES.RENUMBERING | transform: getTooltipText.bind(this) | translate">
        <q9-icon-button
          class="sb-toolbar-actions"
          icon="123"
          [disabled]="isViewMode()"
          (click)="renumber()"></q9-icon-button>
      </div>

      <div
        *ngIf="!isFlowlineDisabled()"
        [matTooltip]="BUTTON_TYPES.FLOWLINE | transform: getTooltipText.bind(this) | translate">
        <q9-icon-button
          #flowlineDragElement
          class="sb-toolbar-actions"
          icon="flowline_icon_v2"
          [disabled]="isViewMode()"></q9-icon-button>
      </div>

      <div
        *ngIf="!isTextDisabled()"
        [matTooltip]="
          (isAgentInstruction() ? BUTTON_TYPES.GUARDRAIL : BUTTON_TYPES.TEXT)
            | transform: getTooltipText.bind(this)
            | translate
        ">
        <q9-icon-button
          #textDragElement
          class="sb-toolbar-actions"
          [icon]="isAgentInstruction() ? 'policies' : 'text_icon_v2'"
          [disabled]="isViewMode()"></q9-icon-button>
      </div>

      <q9-icon-button
        *ngIf="!isStickerNoteDisabled()"
        #stickerDragElement
        class="sb-toolbar-actions"
        icon="sticky_note_icon_v2"
        [class.is-pressed]="showStickerToolbar()"
        [attr.aria-pressed]="showStickerToolbar()"
        (click)="toggleStickerNoteToolbar()"
        [matTooltip]="TOOLTIPS[BUTTON_TYPES.STICKER] | translate"></q9-icon-button>

      <div
        *ngIf="!isImageDisabled()"
        [matTooltip]="BUTTON_TYPES.IMAGE | transform: getTooltipText.bind(this) | translate">
        <q9-icon-button
          #imageDragElement
          class="sb-toolbar-actions"
          icon="image_icon_v2"
          [disabled]="isViewMode()"></q9-icon-button>
      </div>

      <app-agentforce-generate-actions
        *ngIf="showAgentforce()"
        [diagramJson$]="diagramJson$"
        [isViewMode]="isViewMode()"></app-agentforce-generate-actions>
    </div>
  </q9-toolbar>
</div>

<app-activity-toolbar *ngIf="showActivityToolbar()"></app-activity-toolbar>
<app-sticker-note-toolbar *ngIf="showStickerToolbar()"></app-sticker-note-toolbar>
